import CheckinStore from "./CheckInStore";
import CheckinContainer from "./CheckinContainer";


export default CheckinStore(CheckinContainer); 